import { render } from "./LicenseBanner.vue?vue&type=template&id=416e4958"
import script from "./LicenseBanner.vue?vue&type=script&lang=js"
export * from "./LicenseBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__